export interface Colors {
  white: string;
  gray: string;
  black: string;
}

const colors: Colors = {
  white: "#fafafa",
  gray: "#CECECE",
  black: "#4A4A4A",
};

export default colors;
